export default __webpack_public_path__ + "static/media/040-use soap.a6312f76.svg";